import React, { useState, useEffect } from 'react';
import { SelectChangeEvent } from '@mui/material';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import FormHelperText from '@mui/material/FormHelperText';
import { CommonTextField } from 'gemlux-common-components';
import { theme } from '../../theme/theme';
import WarningSvg from '../../assets/img/V1/red-warning.svg';
import CustomDropdown from '../V1/CustomDropdown/CustomDropdown';

interface IRoleDropdownProps {
  options: Array<{ value: string; label: string }>;
  onChange: (_event: SelectChangeEvent<unknown>, _otherValue?: string) => void;
  value: string;
  name: string;
  onBlur: (_event: React.FocusEvent<HTMLInputElement>) => void;
  errorOther?: string;
  error?: string;
  ariaLabelledBy: string;
  disabled?: boolean;
}

const RoleDropdown = ({ options, onChange, value, errorOther, error, ...props }: IRoleDropdownProps) => {
  const [otherValue, setOtherValue] = useState('');

  useEffect(() => {
    if (value !== '7') {
      setOtherValue('');
    }
  }, [value]);

  const handleChange = (event: SelectChangeEvent<unknown>) => {
    const newValue = event.target.value as string;

    if (newValue !== '7') {
      setOtherValue('');
    }

    onChange(event, newValue === '7' ? otherValue : undefined);
  };

  const handleOtherValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setOtherValue(newValue);

    const selectEvent: SelectChangeEvent<unknown> = {
      target: { value: '7', name: props.name },
      type: 'change',
    } as SelectChangeEvent<unknown>;

    onChange(selectEvent, newValue);
  };

  const displayError = value === '7' && errorOther ? errorOther : undefined;

  return (
    <Box>
      <CustomDropdown
        {...props}
        options={options}
        onChange={handleChange}
        value={value}
        error={value !== '7' && error ? error : undefined}
      />

      {value === '7' && (
        <CommonTextField
          fullWidth
          size="small"
          value={otherValue}
          onChange={handleOtherValueChange}
          placeholder="Please specify your role"
          error={Boolean(errorOther)}
          onBlur={props.onBlur}
          data-test-id="combobox"
          aria-labelledby={props.ariaLabelledBy}
          disabled={props.disabled}
          sx={{ marginTop: '8px' }}
        />
      )}
      {displayError && (
        <FormHelperText
          sx={{
            ...theme.typography.textSM,
            color: '#DF0C3D',
            marginTop: '4px',
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            padding: '6px',
          }}
        >
          <Box component="img" src={WarningSvg} alt="Warning icon" sx={{ width: 16, height: 16, marginRight: 1 }} />
          {displayError}
        </FormHelperText>
      )}
    </Box>
  );
};

export default RoleDropdown;
